import VariationResponse from './variationResponse';

class ProductResponse {
  constructor({
    id,
    title,
    description,
    characteristics,
    createdAt,
    updatedAt,
    publishedAt,
    brand,
    categories,
    collection,
    jewelry_type,
    variations,
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.characteristics = characteristics;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.publishedAt = publishedAt;
    this.brand = brand;
    this.categories = categories.map((cat) => cat);
    this.collection = collection;
    this.jewelryType = jewelry_type;
    this.variations = this.sortVariations(
      variations.map((cat) => new VariationResponse(cat)),
    );
  }

  sortVariations(variations) {
    const sorted = variations.sort((a, b) => a.wholesalePrice - b.whoselaPrice);
    return sorted;
  }
}

export default ProductResponse;
